import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";

// HP4 draft — "Shop by skin type or concern" horizontal card slider.
// Non-functional visual draft: cards link to Riversol concern collections.
const TYPES = [
  { title: "Normal to Dry", image: "https://images.unsplash.com/photo-1786520990372-9173e3ffb8a4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", href: "https://www.riversol.com/collections/all" },
  { title: "Very Dry", image: "https://images.unsplash.com/photo-1581182786510-168e6bc0013d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", href: "https://www.riversol.com/collections/all/filter:dehydration" },
  { title: "Oily", image: "https://images.unsplash.com/photo-1581182815808-b6eb627a8798?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", href: "https://www.riversol.com/collections/all" },
  { title: "Combination", image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_e3513a08-18b3-459d-901e-2457595c9150/artifacts/am7jb2tt_ChatGPT%20Image%20Sep%205%2C%202026%2C%2012_25_28%20AM.png", href: "https://www.riversol.com/collections/all/filter:textural_irregularities" },
  { title: "Redness Control", image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_e3513a08-18b3-459d-901e-2457595c9150/artifacts/ff9m18dp_ChatGPT%20Image%20Sep%205%2C%202026%2C%2012_07_31%20AM.png", href: "https://www.riversol.com/collections/all/filter:redness" },
  { title: "Sensitive", image: "https://images.unsplash.com/photo-1643379855542-82c0c7483f3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", href: "https://www.riversol.com/collections/all/filter:redness" },
];

export const ShopBySkinTypeV4 = () => {
  const trackRef = useRef(null);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const nudge = (dir) => {
    const el = trackRef.current;
    if (el) el.scrollBy({ left: dir * (el.clientWidth * 0.6), behavior: "smooth" });
  };
  const navBtn = "w-11 h-11 rounded-full border border-neutral-300 text-neutral-800 hover:border-riversol-blue hover:bg-riversol-blue hover:text-white transition-colors flex items-center justify-center";

  return (
    <section ref={ref} className="bg-white pt-14 lg:pt-20 pb-16 lg:pb-24" data-testid="hp4-shop-by-skin-type">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="flex items-end justify-between gap-6 mb-8 lg:mb-10">
          <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-neutral-500">Shop by skin type or concern</div>
          <div className="hidden lg:flex items-center gap-2">
            <button type="button" onClick={() => nudge(-1)} aria-label="Previous" data-testid="hp4-skin-prev" className={navBtn}><ArrowLeft size={16} strokeWidth={1.8} /></button>
            <button type="button" onClick={() => nudge(1)} aria-label="Next" data-testid="hp4-skin-next" className={navBtn}><ArrowRight size={16} strokeWidth={1.8} /></button>
          </div>
        </div>
        <div ref={trackRef} className="flex gap-4 lg:gap-6 overflow-x-auto snap-x snap-mandatory scrollbar-none -mx-1 px-1" style={{ scrollbarWidth: "none" }}>
          {TYPES.map((t, i) => (
            <motion.a
              key={t.title}
              href={t.href}
              data-testid={`hp4-skin-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
              className="group relative shrink-0 snap-start basis-[78%] sm:basis-[46%] lg:basis-[calc(25%-1.125rem)] aspect-[3/4] overflow-hidden rounded-sm bg-neutral-100"
            >
              <img src={t.image} alt={t.title} className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05]" draggable={false} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
              <h3 className="absolute inset-x-0 bottom-0 p-5 text-white text-[19px] lg:text-[22px] tracking-[-0.01em]">{t.title}</h3>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShopBySkinTypeV4;
